<div class="code-container">
  <code>
    @if (objectForHTML.length === 0) {
      <pre>
        <ng-content></ng-content>
      </pre>
    }
    @for (variable of objectForHTML; track variable) {
      <pre class="object-destruction">
        {{variable.key}}: {{variable.type}}
        <span class="object-comments">{{getDescription(variable.key)}}</span>
      </pre>
    }
  </code>
</div>
